import React from 'react'
import { Grid, CircularProgress } from '@mui/material'
import CompleteDiscoveryIcon from '../Icons/CompletedDiscoveryIcon'
import IncompleteDiscoveryIcon from '../Icons/IncompleteDiscoveryIcon'
import ValidateDiscoveryIcon from '../Icons/ValidateDiscoveryIcon'

const ValidateDiscoveryIcons = ({ organization, missingFields, isLoading }) => {
  return (
    <>
      <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            {organization ? (
              missingFields.length > 0 ? (
                <IncompleteDiscoveryIcon missingFields={missingFields ?? []} />
              ) : (
                <CompleteDiscoveryIcon />
              )
            ) : (
              <ValidateDiscoveryIcon />
            )}
          </>
        )}
      </Grid>
    </>
  )
}

export default ValidateDiscoveryIcons
